import type {
  TrackingPageOrder,
  TrackingPageShipment,
} from "@redotech/redo-model/order-tracking/tracking-page-order-definition";
import { TrackingPageEnvironment } from "../../context/tracking-page-context";

/**
 * Common shipment selection logic used across multiple blocks.
 * Falls back to first shipment with tracking if requested index is invalid.
 */
export function getSelectedShipmentWithFallback(
  shipments: TrackingPageShipment[] | undefined,
  shipmentIndex: string | undefined,
): TrackingPageShipment | undefined {
  if (!shipments?.length) {
    return undefined;
  }

  const index = shipmentIndex ? parseInt(shipmentIndex) : -1;
  const requestedShipment = shipments[index];

  if (requestedShipment) {
    return requestedShipment;
  }

  // Index was invalid or out of bounds — fall back to first shipment with tracking
  return shipments.find((s) => s.trackingCode) ?? shipments[0];
}

/**
 * Get shipment index with builder mode fallback
 */
export function getShipmentIndex(
  paramsShipmentIndex: string | undefined,
  environment: TrackingPageEnvironment,
  order?: TrackingPageOrder,
): string {
  if (environment === TrackingPageEnvironment.BUILDER) {
    if (!order) {
      return "0";
    }
    const index = order.shipments.findIndex(
      (shipment) => shipment.trackingCode,
    );
    return index === -1 ? "0" : index.toString();
  }
  return paramsShipmentIndex || "0";
}
